export default "__VITE_ASSET__294fdf29__"